export default "__VITE_ASSET__B_2Aw2AG__"